import React from 'react';
import { Container, Image, Row, Col, Button, Stack } from 'react-bootstrap';
import { IMAGE_PATHS } from 'constants/imagePaths';
import './styles.scss';
import useTranslate from 'hooks/useTranslate';
import { APP_STORE, PLAY_STORE } from 'constants/index';

const DownloadStassifyApp: React.FC = () => {
	const { translate } = useTranslate();

	return (
		<section className="download-stassify-app py-80">
			<Container>
				<Row>
					<Col lg={9} className="my-auto">
						<Stack className="download-stassify-app-content">
							<h3 className="mb-0 text-capitalize text-white fw-bold">
								{translate('DownloadStassify.downloadMobileApp')}
							</h3>
							<p className="mb-0 text-white">{translate('DownloadStassify.expSeamless')}</p>
						</Stack>
					</Col>
					<Col lg={3} className="my-auto">
						<div className="download-app-buttons d-flex flex-lg-column align-items-lg-end gap-2 gap-lg-4">
							<Button
								className="p-0 border-0 bg-transparent"
								onClick={() => window.open(PLAY_STORE)}
								target="_blank"
								rel="noopener noreferrer"
							>
								<Image
									src={IMAGE_PATHS.GooglePlayBtn}
									className="h-100 w-100 object-fit-contain"
									alt="googlePlayIcon"
									loading="lazy"
								/>
							</Button>
							<Button
								className="p-0 border-0 bg-transparent"
								onClick={() => window.open(APP_STORE)}
								target="_blank"
								rel="noopener noreferrer"
							>
								<Image
									src={IMAGE_PATHS.AppStoreBtn}
									className="h-100 w-100 object-fit-contain"
									alt="appStoreIcon"
									loading="lazy"
								/>
							</Button>
						</div>
					</Col>
				</Row>
			</Container>
		</section>
	);
};

export default DownloadStassifyApp;
